const EN = {
    title: 'Change',
    titleCreate: 'Create',
    title2: 'Password',
    helperText: 'Keep in mind that it cannot be personal data or sequential numbers.',
    helperTextCreate: 'Pick a new password to continue. Keep in mind that it cannot be personal data or sequential numbers.',

    inputs: {
        password: {
            placeholder: 'New password'
        },
        confirmPassword: {
            placeholder: 'Confirm new password'
        },
    },
    help: {
        title: 'The password must have at least: ',
        list: {
            0: '8 characters.',
            1: 'A lower case character.',
            2: 'An upper case character.',
            3: 'A number.',
            4: 'A special character.'
        }
    },
    changePassword: {
        success: 'Your password has been created successfully.',
        error: 'The passwords do not match.'
    },
    recover: {
        success: 'The user has been validated correctly.',
    }
};

export default EN;
